import React from 'react';

const FilterIcon = ({ size = 14, ...props }) => (
  <svg
    width={Math.round((size * 14) / 12.211)}
    height={size}
    viewBox='0 0 14 12.211'
    fill='none'
    stroke='currentColor'
    {...props}>
    <g transform='translate(1.2 0) skewX(-12)'>
      <g transform='translate(-3.897 0.5)'>
        <path d='M8.625,5.292a.691.691,0,0,1,.182.468v5.093A.346.346,0,0,0,9.4,11.1l1.421-1.628c.19-.228.295-.341.295-.567V5.761a.7.7,0,0,1,.182-.468L15.37.87A.519.519,0,0,0,14.988,0H4.929a.518.518,0,0,0-.381.87Z' />
      </g>
    </g>
  </svg>
);

export default FilterIcon;
